(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-pdp-aufbau"] && !Shopify.designMode) return;
  try {
    class SsAufbau {
    constructor(wurzel) {
      this.wurzel = wurzel;
      this.daten = JSON.parse(wurzel.querySelector('[data-ss-aufbau-daten]').textContent);
      this.feld = wurzel.querySelector('[data-ss-plz]');
      this.ausgabe = wurzel.querySelector('[data-ss-result]');
      this.knopf = wurzel.querySelector('[data-ss-add]');
      this.gebucht = false;

      wurzel.querySelector('[data-ss-plz-check]').addEventListener('click', () => this.pruefen());
      this.feld.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.pruefen();
        }
      });
      this.knopf.addEventListener('click', () => this.buchen());
    }

    // Anbieter, die aktiv sind, im Land liefern und zu dieser Variante gehoeren
    get anbieter() {
      return this.daten.anbieterliste.filter(
        (a) => a.aktiv && a.land === this.daten.land && a.name === this.daten.anbieter
      );
    }

    passt(anbieter, plz) {
      const liste = (anbieter.plz || '')
        .split(',')
        .map((teil) => teil.trim())
        .filter(Boolean);
      if (!liste.length) return true; // leere Liste heisst: ganzes Land
      return liste.some((praefix) => plz.startsWith(praefix));
    }

    pruefen() {
      const plz = (this.feld.value || '').trim();
      this.ausgabe.hidden = false;
      this.ausgabe.classList.remove('is-ok');

      if (!/^\d{4,5}$/.test(plz)) {
        this.ausgabe.textContent = this.daten.texte.ungueltig;
        this.knopf.hidden = true;
        return;
      }

      const treffer = this.anbieter.filter((a) => this.passt(a, plz));
      if (!treffer.length) {
        this.ausgabe.innerHTML = '';
        const satz = document.createElement('p');
        satz.textContent = this.daten.texte.kein_treffer;
        const link = document.createElement('a');
        const betreff = encodeURIComponent(`Anfrage Aufbauservice: ${this.daten.produkt} (PLZ ${plz})`);
        link.href = `mailto:${this.daten.mail}?subject=${betreff}`;
        link.textContent = this.daten.texte.anfragen;
        this.ausgabe.append(satz, link);
        this.knopf.hidden = true;
        return;
      }

      this.ausgabe.classList.add('is-ok');
      this.ausgabe.textContent = `${this.daten.texte.treffer} — ${treffer[0].name}`;
      this.knopf.hidden = false;
    }

    async buchen() {
      if (this.gebucht) return;
      const plz = (this.feld.value || '').trim();
      try {
        const antwort = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: this.daten.variante,
            quantity: 1,
            properties: {
              'Für Produkt': this.daten.produkt,
              PLZ: plz,
              Anbieter: this.daten.anbieter,
            },
          }),
        });
        if (!antwort.ok) throw new Error('cart');
        this.gebucht = true;
        this.wurzel.classList.add('is-gebucht');
        this.knopf.textContent = this.daten.texte.gebucht;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (fehler) {
        this.ausgabe.hidden = false;
        this.ausgabe.classList.remove('is-ok');
        this.ausgabe.textContent = this.daten.texte.fehler;
      }
    }
  }

  document.querySelectorAll('[data-ss-aufbau]').forEach((wurzel) => new SsAufbau(wurzel));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-pdp-overlay"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ss-ovl]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.getAttribute('data-ss-ovl'));
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
    }
  });

  // Klick auf den abgedunkelten Hintergrund schliesst das Overlay
  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (dialog.tagName !== 'DIALOG' || !dialog.classList.contains('ss-ovl')) return;
    const box = dialog.getBoundingClientRect();
    const drin =
      event.clientX >= box.left &&
      event.clientX <= box.right &&
      event.clientY >= box.top &&
      event.clientY <= box.bottom;
    if (!drin) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

})();
